import { config } from "JS/Config";
import { Course, CourseDetail } from "JS/Models";
import { BaseService } from "../BaseService";
import { appConstants } from "JS/Helpers/Constants";
import { GiftService } from "../Gift";

export class CoursesService extends BaseService {
    getCourses = () =>
        this.ngCall<Course[]>(
            "get",
            appConstants.ngEndpoints.courseListing(config.user.memberId),
            {
                headers: {
                    authorization: `Bearer ${config.ngAccesstoken}`,
                },
            },
        );

    getPurchasedGiftCourses() {
        const giftService = new GiftService();
        return giftService.getToSendMediaGifts("GiftCourse");
    }

    getCourseDetailWithMedia = (nid: string) =>
        this.ngCall<CourseDetail>(
            "get",
            appConstants.ngEndpoints.courseDetailWithMedia(nid),
            {
                headers: {
                    authorization: `Bearer ${config.ngAccesstoken}`,
                },
            },
        );

    getCourseDetailWithoutMedia = (nid: string) =>
        this.ngCall<CourseDetail>(
            "get",
            appConstants.ngEndpoints.courseDetailWithoutMedia(nid),
            {
                headers: {
                    authorization: `Bearer ${config.ngAccesstoken}`,
                },
            },
        );
}
